/* Dubai Parts wishlist — browser-based (localStorage), no account required.
   Shared across every "add to wishlist" heart button and the wishlist page itself. */
(function () {
  var STORAGE_KEY = 'dp_wishlist_v1';

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private browsing, quota) — fail silently */
    }
  }

  function has(handle) {
    return read().some(function (item) { return item.handle === handle; });
  }

  function add(handle, price, currency) {
    var list = read();
    if (!list.some(function (item) { return item.handle === handle; })) {
      list.push({ handle: handle, price: price || null, currency: currency || null, savedAt: Date.now() });
      write(list);
    }
  }

  function remove(handle) {
    write(read().filter(function (item) { return item.handle !== handle; }));
  }

  function toggle(handle, price, currency) {
    if (has(handle)) {
      remove(handle);
      return false;
    }
    add(handle, price, currency);
    return true;
  }

  function clear() {
    write([]);
  }

  function count() {
    return read().length;
  }

  window.dpWishlist = {
    STORAGE_KEY: STORAGE_KEY,
    read: read,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    clear: clear,
    count: count,
  };

  function updateButtonState(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var active = has(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function updateCountBadges() {
    var n = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function initButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-handle]').forEach(updateButtonState);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-wishlist-handle');
    var price = btn.getAttribute('data-wishlist-price') || '';
    var currency = btn.getAttribute('data-wishlist-currency') || '';
    toggle(handle, price, currency);
    updateButtonState(btn);
    updateCountBadges();
    document.dispatchEvent(new CustomEvent('dp-wishlist:change', { detail: { handle: handle } }));
  });

  function boot() {
    initButtons();
    updateCountBadges();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
